import {ADOBE_ANALYTICS_EVENTS} from 'app/Analytics';
import {analyticsTrack} from 'utilities/analytics';
import * as AppConstants from 'app/AppConstants';
import {
  fetchEnvironment,
  fetchEnvironmentPublic,
  beginTrial as beginTrialService,
  fetchTrialStatus,
  requestUpgrade as requestUpgradeService,
} from './environmentService';
import {
  selectIsEnvironmentLoaded,
  selectHasTrialStatus,
  selectIsPublic,
  selectPublicCardId,
} from './environmentSelectors';

const loadPublic = dispatch => {
  const publicCardId = selectPublicCardId();
  return fetchEnvironmentPublic(publicCardId).then(
    response => {
      dispatch({
        type: AppConstants.ENVIRONMENT__LOAD_ENVIRONMENT_FINISHED,
        payload: response,
      });

      return response;
    },
    () => {
      dispatch({
        type: AppConstants.ENVIRONMENT__LOAD_ENVIRONMENT_FAILED,
      });
    }
  );
};

const loadAuthenticated = dispatch =>
  fetchEnvironment().then(
    response => {
      dispatch({
        type: AppConstants.ENVIRONMENT__LOAD_ENVIRONMENT_FINISHED,
        payload: response,
      });

      return response;
    },
    () => {
      dispatch({
        type: AppConstants.ENVIRONMENT__LOAD_ENVIRONMENT_FAILED,
      });
    }
  );

export const load = () => (dispatch, getState) => {
  const state = getState();
  if (selectIsEnvironmentLoaded(state)) {
    return Promise.resolve();
  }

  dispatch({
    type: AppConstants.ENVIRONMENT__LOAD_ENVIRONMENT_STARTED,
  });

  return dispatch(selectIsPublic(state) ? loadPublic : loadAuthenticated);
};

export const getTrialStatus = () => (dispatch, getState) => {
  const state = getState();
  if (selectHasTrialStatus(state)) return Promise.resolve();
  return fetchTrialStatus().then(response => {
    dispatch({
      type: AppConstants.ENVIRONMENT__TRIAL_STATUS_LOADED,
      payload: response,
    });
  });
};

export const beginTrial = () => {
  analyticsTrack(ADOBE_ANALYTICS_EVENTS.SOCIAL_USER__TRIAL_STARTED_CONFIRMED);
  return dispatch => {
    dispatch({
      type: AppConstants.ENVIRONMENT__BEGAN_TRIAL_STARTED,
    });
    beginTrialService().then(
      response => {
        dispatch({
          type: AppConstants.ENVIRONMENT__BEGAN_TRIAL_FINISHED,
        });
        return response;
      },
      () => {
        dispatch({
          type: AppConstants.ENVIRONMENT__BEGAN_TRIAL_FAILED,
        });
      }
    );
  };
};

export const requestUpgrade = () => {
  analyticsTrack(ADOBE_ANALYTICS_EVENTS.SOCIAL_USER__UPGRADE_REQUESTED);
  return dispatch => {
    dispatch({
      type: AppConstants.ENVIRONMENT__REQUEST_UPGRADE_STARTED,
    });
    requestUpgradeService().then(
      response => {
        dispatch({
          type: AppConstants.ENVIRONMENT__REQUEST_UPGRADE_FINISHED,
        });
        return response;
      },
      () => {
        dispatch({
          type: AppConstants.ENVIRONMENT__REQUEST_UPGRADE_FAILED,
        });
      }
    );
  };
};
